import { component } from 'picoapp';
import Swiper, { SwiperOptions, Pagination } from 'swiper';

export default component((node: HTMLElement) => {
  /**
   * Main images slider
   */

  // Create and init main slider
  const sliderElem: HTMLElement = node.querySelector('[data-mobile-slider]');
  const swiperConfig: SwiperOptions = {
    modules: [Pagination],
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    slidesPerView: 1,
    init: false,
    spaceBetween: 0,
  };

  const mobileSlider = new Swiper(sliderElem, swiperConfig);
  mobileSlider.init();

  /**
   * Nav slider
   */

  // Create and init nav slider
  const navElem: HTMLElement = node.querySelector('[data-mobile-nav-slider]');
  const navConfig: SwiperOptions = {
    slidesPerView: 5,
    init: false,
    spaceBetween: 4,
  };

  const mobileNavSlider = new Swiper(navElem, navConfig);
  mobileNavSlider.init();

  // Change slide when clicking on nav slides
  const navItems = node.querySelectorAll('[data-mobile-nav-image]');
  navItems.forEach((nav, index) => {
    nav.addEventListener('click', () => {
      mobileSlider.slideTo(index);
    });
  });
});
